// extracted by css-extract-rspack-plugin
export default {"card":"t6ej9xN48h8e9f80__card___","sparkles":"I9g0DWHfocyPm7T1__sparkles___","text":"Ht3CrxMU2s8Dv4xw__text___"};